import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import api from '../../services/api';
import { toast } from 'react-toastify';

const PaymentCallback = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('processing');
  const [message, setMessage] = useState('Processing your payment...');

  useEffect(() => {
    const checkPaymentStatus = async () => {
      try {
        // Try to get order ID from URL params first, then from sessionStorage
        let orderId = searchParams.get('order_id');

        if (!orderId) {
          orderId = sessionStorage.getItem('pendingOrderId');
        }

        const paymentStatus = searchParams.get('status');

        if (!orderId) {
          setStatus('error');
          setMessage('Invalid payment information');
          return;
        }

        // Clear sessionStorage
        sessionStorage.removeItem('pendingOrderId');

        // Poll the backend to check if the event has been created
        let attempts = 0;
        const maxAttempts = 15;

        const checkInterval = setInterval(async () => {
          attempts++;

          try {
            const response = await api.get(`/organizer/payment-status/${orderId}`);

            if (response.data.payment_status === 'paid' && response.data.event_created) {
              clearInterval(checkInterval);
              setStatus('success');
              setMessage('Payment successful! Your event has been saved.');
              toast.success('Event saved successfully!');

              // Redirect to events page after 3 seconds
              setTimeout(() => {
                navigate('/organizer/events');
              }, 3000);
            } else if (response.data.payment_status === 'failed') {
              clearInterval(checkInterval);
              setStatus('error');
              setMessage('Payment failed. Please try again.');
              setTimeout(() => {
                navigate('/organizer/events');
              }, 3000);
            }
          } catch (error) {
            console.error('Error checking payment status:', error);
          }

          // Stop checking after max attempts
          if (attempts >= maxAttempts) {
            clearInterval(checkInterval);
            setStatus('warning');
            setMessage('Payment is being processed. Please check your events list shortly.');
            setTimeout(() => {
              navigate('/organizer/events');
            }, 5000);
          }
        }, 3000); // Check every 3 seconds

      } catch (error) {
        console.error('Payment callback error:', error);
        setStatus('error');
        setMessage('An error occurred while processing your payment');
      }
    };

    checkPaymentStatus();
  }, [searchParams, navigate]);

  return (
    <div className="container-fluid">
      <div className="row justify-content-center align-items-center" style={{ minHeight: '80vh' }}>
        <div className="col-md-6">
          <div className="card shadow-lg">
            <div className="card-body text-center py-5">
              {status === 'processing' && (
                <>
                  <div className="mb-4">
                    <div className="spinner-border text-primary" style={{ width: '4rem', height: '4rem' }} role="status">
                      <span className="sr-only">Loading...</span>
                    </div>
                  </div>
                  <h3 className="text-primary mb-3">Processing Payment</h3>
                  <p className="text-muted">{message}</p>
                </>
              )}

              {status === 'success' && (
                <>
                  <div className="mb-4">
                    <i className="fas fa-check-circle text-success" style={{ fontSize: '5rem' }}></i>
                  </div>
                  <h3 className="text-success mb-3">Payment Successful!</h3>
                  <p className="text-muted">{message}</p>
                  <p className="text-muted small">Redirecting to your events...</p>
                </>
              )}

              {status === 'warning' && (
                <>
                  <div className="mb-4">
                    <i className="fas fa-exclamation-triangle text-warning" style={{ fontSize: '5rem' }}></i>
                  </div>
                  <h3 className="text-warning mb-3">Payment Processing</h3>
                  <p className="text-muted">{message}</p>
                  <p className="text-muted small">Redirecting to your events...</p>
                </>
              )}

              {status === 'error' && (
                <>
                  <div className="mb-4">
                    <i className="fas fa-times-circle text-danger" style={{ fontSize: '5rem' }}></i>
                  </div>
                  <h3 className="text-danger mb-3">Payment Failed</h3>
                  <p className="text-muted">{message}</p>
                  <button
                    className="btn !bg-yellow-400 !text-white hover:!bg-yellow-500 mt-3"
                    onClick={() => navigate('/organizer/events')}
                  >
                    Try Again
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentCallback;

